export const apiPaths = {
  campaigns: {
    get: "/api/v1/campaigns",
  },
  abTesting: {
    postSessionVariants: "/api/v1/ab-testing/session-variants",
  },
  sessionAudit: {
    post: "/api/v1/session-audit",
  },
  hotels: {
    getHotelInfo: "/api/v1/hotels/:hotelId/info",
    getHotelsInfo: "/api/v1/hotels/info",
    getHotelDealsV2: "/api/v2/hotels/:hotelId/deals",
    getHotelsAvailability: "/api/v1/hotels/availability",
    getHotelsSourceLinks: "/api/v1/hotels/source-links",
  },
  rooms: {
    getRoomsInfo: "/api/v1/rooms/info",
  },
  hotelOffers: {
    get: "/api/v1/hotels/offers",
    track: "/api/v1/hotels/offers/track",
  },
  checkout: {
    get: "/api/v1/checkout/:checkoutId",
    verifyCredits: "/api/v1/checkout/:checkoutId/credit/verify",
    getInsuranceQuote: "/api/v1/checkout/:checkoutId/cancellation-insurance/quote",
    createPrefillToken: "/api/v1/checkout/prefill/token",
    getPrefillData: "/api/v1/checkout/prefill/get",
  },
  trips: {
    get: "/api/v2/trips/get-trip",
    status: "/api/v2/trips/status",
    modification: {
      getOptions: "/api/v1/trips/:tripKey/modification/date-options",
      getCheckout: "/api/v1/trips/:tripKey/modification/checkout/:checkoutId",
      submitCheckout: "/api/v1/trips/:tripKey/modification/checkout/:checkoutId/submit",
    },
    getList: "/api/v1/trips/list",
    create: "/api/v1/trips",
    cancel: "/api/v2/trips/:tripKey",
    restoreBookingNumber: "/api/v1/trips/booking-number/recovery",
    getTripKey: "/api/v2/trips/trip-key",
    sendItinerary: "/api/v2/trips/:tripKey/send-itinerary",
    sendReceipt: "/api/v2/trips/:tripKey/send-receipt",
    getReviewLink: "/api/v1/trips/:tripKey/review",
  },
  customerSupport: {
    createTicket: "/api/v2/customer-support/tickets",
  },
  geolocation: {
    get: "/api/v1/location",
  },
  places: {
    getPlace: "/api/v1/places/:placeId",
    findPlaces: "/api/v1/places",
  },
  additionalPayment: {
    get: "/api/v1/trips/:tripKey/additional-payment/:paymentRequestKey",
    post: "/api/v1/trips/:tripKey/additional-payment/:paymentRequestKey",
  },
  phones: {
    sendVerificationCode: "/api/v1/users/verification/phone",
  },
  authentication: {
    byPhone: "/api/v1/authentication/phone",
    byEmail: "/api/v1/authentication/email",
    oauth: "/api/v1/authentication/oauth",
    logout: "/api/v1/authentication/logout",
  },
  users: {
    getInfo: "/api/v1/users",
    update: "/api/v1/users",
    updatePassword: "/api/v1/users/password",
    registerByEmail: "/api/v1/users/register/email",
    exists: "/api/v1/users/exists",
    startResetPassword: "/api/v1/users/password-resets/start",
    completeResetPassword: "/api/v1/users/password-resets/complete",
    delete: "/api/v1/users",
    deleteV2: "/api/v2/users",
    sendAccountDeletionCode: "/api/v1/users/account-deletion/code",
    facebookDeletionStatus: "/api/v1/users/account-deletion/facebook/status",
  },
} as const;
